import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { BackOfficeRoutes } from "@routes/urls";
import LiteratureTitle from "@modules/Literature/LiteratureTitle";

const BookDetailsDisplay = ({ loans, urlLoanId }) => {
  return (
    <div>
      {loans.map((loan, index) => (
        <div key={index} style={{ marginBottom: "4px" }}>
          <Link to={BackOfficeRoutes.loanDetailsFor(loan.metadata.pid)}>
            <LiteratureTitle
              title={loan.metadata.document.title}
              edition={loan.metadata.document.edition}
              publicationYear={loan.metadata.document.publication_year}
            />
          </Link>
        </div>
      ))}
    </div>
  );
};

BookDetailsDisplay.propTypes = {
  loans: PropTypes.arrayOf(
    PropTypes.shape({
      metadata: PropTypes.shape({
        pid: PropTypes.string.isRequired,
        document: PropTypes.shape({
          title: PropTypes.string.isRequired,
          edition: PropTypes.string,
          publication_year: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
          ]),
        }).isRequired,
      }).isRequired,
      calculatedFine: PropTypes.number.isRequired,
    })
  ).isRequired,
  urlLoanId: PropTypes.string,
};

BookDetailsDisplay.defaultProps = {
  urlLoanId: null,
};

export default BookDetailsDisplay;
